import GeneratorView from "../../components/GeneratorView";
import GeneratorOptions from "./GeneratorOptions";
import BigInt from "big-integer";

const fibSequence = (max) => {
  let results = [BigInt(0), BigInt(1)];
  for (let i = 2; i <= max; i++) {
    results[i] = results[i - 1].add(results[i - 2]);
  }
  return max === 0 ? [] : results.slice(0, max);
};

const generate = ({ count }) => fibSequence(count || 0);

const Index = ({ strings }) => (
  <GeneratorView
    strings={strings}
    onGenerate={generate}
    optionsView={GeneratorOptions}
    options={{ count: 500 }}
  />
);

export default Index;
